import { render, staticRenderFns } from "./SysConfigCenter.vue?vue&type=template&id=4fb46a00&scoped=true"
import script from "./SysConfigCenter.vue?vue&type=script&lang=js"
export * from "./SysConfigCenter.vue?vue&type=script&lang=js"
import style0 from "./SysConfigCenter.vue?vue&type=style&index=0&id=4fb46a00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb46a00",
  null
  
)

export default component.exports